import { Search } from 'lucide-react'
import type { ReactNode } from 'react'

export function PageHeader({ eyebrow, title, description, actions }: { eyebrow?: string; title: string; description?: string; actions?: ReactNode }) {
  return <header className="page-header"><div>{eyebrow && <span className="eyebrow">{eyebrow}</span>}<h1>{title}</h1>{description && <p>{description}</p>}</div>{actions && <div className="page-actions">{actions}</div>}</header>
}

export function StatusBadge({ tone = 'neutral', children }: { tone?: 'success' | 'warning' | 'danger' | 'info' | 'neutral'; children: ReactNode }) {
  return <span className={`status-badge status-badge--${tone}`}>{children}</span>
}

export function SearchInput({ value, onChange, placeholder = 'Tìm kiếm…' }: { value: string; onChange: (value: string) => void; placeholder?: string }) {
  return <label className="search-input"><Search size={17} aria-hidden="true" /><span className="sr-only">Tìm kiếm</span><input type="search" value={value} onChange={(event) => onChange(event.target.value)} placeholder={placeholder} /></label>
}

export function MetricCard({ label, value, hint, icon }: { label: string; value: ReactNode; hint?: string; icon?: ReactNode }) {
  return <article className="metric-card"><div className="metric-card__label"><span>{label}</span>{icon}</div><strong>{value}</strong>{hint && <p>{hint}</p>}</article>
}

export function ChartCard({ title, description, children }: { title: string; description?: string; children: ReactNode }) {
  return <section className="panel chart-card"><div className="panel__header"><div><h2>{title}</h2>{description && <p>{description}</p>}</div></div>{children}</section>
}

export function CapabilityNotice({ title = 'Cần backend bổ sung', children }: { title?: string; children: ReactNode }) {
  return <div className="capability-notice"><StatusBadge tone="warning">Chưa khả dụng</StatusBadge><div><strong>{title}</strong><p>{children}</p></div></div>
}
